import React from "react";

const CancelButton = ({ title, onClick }) => (
    <button type="button" onClick={onClick} className="mdl-button mdl-button--raised mdl-js-ripple-effect btn-circle">
        {title} <i className="material-icons text-danger">close</i>
    </button>
);

export default CancelButton;
